import { SnackbarAction } from "notistack";
import { versionService } from "../../services/versionService";
import { SystemEntityCollections } from "../../shared/enums/shared-enums";
import { Version, VersionFilters } from "../../types/version";
import { useEntityQueryClient } from "./entityQueryClient";
import { extractVersionViewLink } from "../../components/entitiesReferences/InternalEntityLink";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useVersionLogic from "../logic/versionLogic";

const useVersionQuery = (
  systemLanguageType: Version["system_language_type"]
) => {
  const navigate = useNavigate();
  const { defaultVersion, getDisplayName } =
    useVersionLogic(systemLanguageType);
  return useEntityQueryClient<Version, VersionFilters>({
    service: versionService,
    collection: SystemEntityCollections.VERSION,
    defaultEntity: defaultVersion,
    snackbarDisplayName: getDisplayName,
    snackbarAction: (data: Version): SnackbarAction => (
      <Button
        variant="text"
        onClick={() => navigate(extractVersionViewLink(data))}
        sx={{ color: "white" }}
      >
        View Version
      </Button>
    ),
  });
};

export default useVersionQuery;
